import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/ui/PageWrapper';
import FadeUp from '../components/ui/FadeUp';
import CTASection from '../components/sections/CTASection';
import { useContent } from '../hooks/useContent';

export default function Services() {
  const { content } = useContent();
  const s = content?.servicesPage;
  const categories = s?.categories ?? [];

  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 30% 50%, rgba(232,135,26,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">{s?.eyebrow ?? 'Our Consultancy Services'}</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}>
              {s?.title ?? 'Align Your Space. Transform Your Life.'}
            </h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 600, lineHeight: 1.8 }}>
              {s?.subtitle}
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div className="services-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 28 }}>
            {categories.map((cat: any, i: number) => (
              <FadeUp key={i} delay={i * 0.1}>
                <div style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.12)', borderRadius: 14, padding: '36px 28px', height: '100%' }}>
                  <div style={{ fontSize: 32, marginBottom: 16 }}>{cat.icon}</div>
                  <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, marginBottom: 12 }}>{cat.title}</h2>
                  <p style={{ fontSize: 14, lineHeight: 1.7, opacity: 0.65, marginBottom: 24 }}>{cat.desc}</p>
                  <ul style={{ listStyle: 'none', marginBottom: 28 }}>
                    {(cat.features ?? []).map((f: string, j: number) => (
                      <li key={j} style={{ fontSize: 13, opacity: 0.7, marginBottom: 8, display: 'flex', gap: 8 }}>
                        <span style={{ color: '#E8871A' }}>✦</span> {f}
                      </li>
                    ))}
                  </ul>
                  <Link to={cat.path} className="btn-outline" style={{ fontSize: 13, padding: '10px 20px' }}>
                    Enquire Now
                  </Link>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <CTASection />

      <style>{`
        @media (max-width: 768px) { .services-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </PageWrapper>
  );
}
